import { useMemo } from 'react';
import { useOrganization } from '@/contexts/OrganizationContext';
import { resolveBranding, type ResolvedBranding } from '@/lib/branding';

export function useBranding(): ResolvedBranding {
  const { organization } = useOrganization();
  return useMemo(() => resolveBranding(organization), [organization]);
}
